import i18n from "../i18n/config";

// Get translation function - this will be called dynamically in components
export const getPalmAdjustmentMap = (): Record<number, string> => {
  const t = (key: string) => i18n.t(key);
  return {
    0: t("palmAdjustment.perfect"),
    1: t("palmAdjustment.moveHandLeft"),
    2: t("palmAdjustment.moveHandRight"),
    3: t("palmAdjustment.moveHandUp"),
    4: t("palmAdjustment.moveHandDown"),
    5: t("palmAdjustment.moveHandCloser"),
    6: t("palmAdjustment.moveHandFarther"),
    7: t("palmAdjustment.rotateHandUpward"),
    8: t("palmAdjustment.rotateHandParallel"),
    9: t("palmAdjustment.flipHandOver"),
    10: t("palmAdjustment.spreadFingers"),
    11: t("palmAdjustment.straightenFingers"),
    12: t("palmAdjustment.spreadThumb"),
    13: t("palmAdjustment.straightenThumb"),
    20: t("palmAdjustment.brightenHand"),
    21: t("palmAdjustment.darkenHand"),
    22: t("palmAdjustment.focusHand"),
    23: t("palmAdjustment.keepStill"),
    // 99: "No_Palm",
    // 100: "Other",
  };
};

// Keep backward compatibility - but this won't update dynamically
// Components should use getPalmAdjustmentMap() instead
export const PalmAdjustmentMap: Record<number, string> = getPalmAdjustmentMap();

export const PalmGestureMap: Record<number, string> = {
  0: "PalmGesture_None",
  1: "PalmGesture_Pointing",
  2: "PalmGesture_Scissors",
  3: "PalmGesture_Three",
  4: "PalmGesture_Four",
  6: "PalmGesture_Fist",
  7: "PalmGesture_Thumbs_Up",
  8: "PalmGesture_L",
  9: "PalmGesture_Paper",
  10: "PalmGesture_Circle",
  11: "PalmGesture_Back",
  12: "PalmGesture_Shaka",
  13: "PalmGesture_Double_L",
};

export const PalmStrictnessMap: Record<number, string> = {
  [-1]: "PalmStrictness_None",
  0: "PalmStrictness_Minimum",
  1: "PalmStrictness_Authenticate",
  2: "PalmStrictness_Medium",
  3: "PalmStrictness_Enrollment",
  4: "PalmStrictness_Enrollment_Unique",
  5: "PalmStrictness_Maximum",
};

export const PalmLivenessMap: Record<number, string> = {
  0: "PalmLiveness_None",
  1: "PalmLiveness_Gesture",
  2: "PalmLiveness_HiRes",
  3: "PalmLiveness_HiRes_Gesture",
  4: "PalmLiveness_Touch",
};

export const PalmCaptureStatusMap: Record<number, string> = {
  0: "PalmCaptureStatus_Idle",
  1: "PalmCaptureStatus_Capture",
  2: "PalmCaptureStatus_Liveness",
  4: "PalmCaptureStatus_Success",
  5: "PalmCaptureStatus_Fail",
  3: "PalmCaptureStatus_Liveness_Phase_2",
};
